import { IHomeState } from './home';

const homeState: IHomeState = {
    listItems: [],
    countNtf: 0,
    expiredTimeBuy: 0,
    listCollectionsNotMint: [],
    listCollectionsMinted: [],
    listTokenSell: [],
    feeSell: 0,
    reCallApi: false,
};
export default homeState;
